/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React, { useState, useEffect } from "react";
import { getLanguages } from "../services/languageServices";
import { getNamespaces } from "../services/namespaceServices";
import { fetchPromptSettings, savePromptsSettings } from "../utility/lookupHelper";
import PromptsTable from "./PromptsTable";
import { ProgressOverlay } from "../../../components/Common";
import { EmptyPlaceholder } from "../../../components";

const PromptsManager = () => {
	const [lookup, setLookup] = useState({ languages: [], namespaces: [], selectedSettings: {} });
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const init = async () => {
			const languageArr = (await getLanguages()).sort();
			const namespaceArr = (await getNamespaces()).sort();

			const promptSettings = fetchPromptSettings();

			// check that local storage settings still exist in the
			// namespace and language lists fetch from the server
			if (languageArr.length && !languageArr.find((x) => x === promptSettings.language)) {
				promptSettings.language = languageArr[0];
			}

			if (namespaceArr.length && !namespaceArr.find((x) => x === promptSettings.namespace)) {
				promptSettings.namespace = namespaceArr[0];
			}

			savePromptsSettings(promptSettings);

			setLookup({ languages: languageArr, namespaces: namespaceArr, selectedSettings: promptSettings });
			setIsLoading(false);
		};

		init();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const { languages, namespaces, selectedSettings } = lookup;
	const hasDefinedSettings = languages?.length > 0 && namespaces?.length > 0;

	return (
		<>
			{isLoading ? (
				<ProgressOverlay />
			) : hasDefinedSettings ? (
				<PromptsTable settings={selectedSettings} languages={languages} namespaces={namespaces} />
			) : (
				<EmptyPlaceholder message="No supported languages and namespaces defined. Please define supported languages and namespaces." />
			)}
		</>
	);
};

export default PromptsManager;
